import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import { makeStyles } from '@material-ui/core/styles';
import EventEmitter from 'utils/events';
import { EventEmitterTypes } from 'utils/constants';
import { useViewport } from 'utils/getViewport/getViewport';
import './AddParticipant.scss';

const useStyles = makeStyles(theme => ({
  addParticipantIconButton: {
    '&.Mui-focusVisible': {
      background: theme?.palette?.icon?.iconHoverColor
    },
    '&:hover': {
      background: theme?.palette?.icon?.iconHoverColor
    }
  }
}));

export default function AddParticipant() {
  const classes = useStyles();
  const [showParticipantModal, setShowPaticipantModal] = useState(false);
  const { isMobile } = useViewport();

  const toggleAddParticipantsModal = () => {
    if (isMobile) {
      EventEmitter.dispatch(EventEmitterTypes.TOGGLE_MOBILE_SIDEBAR, { right: 'right', open: showParticipantModal });
    }
    EventEmitter.dispatch(EventEmitterTypes.TOGGLE_ADD_PARTICIPANTS, { openSidebar: true });
    setShowPaticipantModal(!showParticipantModal);
  };
  return (
    <div className="participant-details-header">
      <IconButton
        data-testid="participantsPanel-addParticipant-button"
        className={`${classes.addParticipantIconButton} add-participant-link`}
        size="small"
        onClick={toggleAddParticipantsModal}
        disableRipple
      >
        <GroupAddIcon className="add-participant-icon" />
      </IconButton>
    </div>
  );
}
